/**
 * Created by BJ Rutledge
 * Date:2024-12-26
 * We need to be able to access the job data from the Total-Output-Data.json file
 * throughout the app. This context provider will allow us to do that.
 **/
import React, { createContext, useContext, useState, useEffect, useCallback, ReactNode } from 'react';
import totalOutputData from '../data/Total-Output-Data.json';
import { SbcOutputData } from '../models/types';
import { SbcOutputDataContextProps } from '../models/interfaces';

const SbcOutputDataContext = createContext<SbcOutputDataContextProps | undefined>(undefined);

export const SbcOutputDataProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [data, setData] = useState<SbcOutputData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    try {
      setData(totalOutputData);
    } catch (err) {
      setError('Error loading data');
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <SbcOutputDataContext.Provider value={{ data, loading, error }}>
      {children}
    </SbcOutputDataContext.Provider>
  );
};

export const useSbcOutputData = () => {
  const context = useContext(SbcOutputDataContext);
  if (context === undefined) {
    throw new Error('useSbcOutputData must be used within a SbcOutputDataProvider');
  }
  return context;
};